import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import TaskWorkingBody from "components/TaskWorking/TaskWorkingBody";

const TaskWorking = () => {
  // -------- for title ------------
  useEffect(() => {
    document.title = "Working Tasks";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="taskworking" />

      <TaskWorkingBody />
    </main>
  );
};

export default TaskWorking;
